import Files from "@mui/icons-material/FileCopy";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import visa from '../../assets/backoffice/visa.png';
import mastercard from '../../assets/backoffice/mastercard.png';
import jcb from '../../assets/backoffice/jcb.png';
const transactionData = [
  {
    id: {
      line1: "5c85b55302 ... 4c4884d3b7",
      line2: "08S-509ffbd ... 5d74463f8be",
      line3: "2213351633",
    },
    terminal: {
      type: "DIRECT / CALLBACK-UP",
      code: "FDSFSDGERG34HG2GF",
    },
    amount: "10.00 EUR",
    payer: {
      country: "FR",
      name: "Denis Franklin",
    },
    logo: mastercard,
    logoWidth: "31px",
    logoHeight: "24px"
  },
  {
    id: {
      line1: "fff7cd4414 ... b02efa1c18",
      line2: "08S-89516e9 ... d85ec53f285",
      line3: "2213351575",
    },
    terminal: {
      type: "DIRECT / DEPOSIT",
      code: "QDGATL8Q9HMZEKA",
    },
    amount: "10.00 EUR",
    payer: {
      country: "KW",
      name: "Ruiz Dagibero",
    },
    logo: visa,
    logoWidth: "44px",
    logoHeight: "14px"
  },
  {
    id: {
      line1: "1029262343",
      line2: "08S-26b8a0e ... 65fe6a6e2f2",
      line3: "53a710fa10 ... 4759e136e1",
    },
    terminal: {
      type: "DIRECT / DEPOSIT",
      code: "QDGDLGTHB89CLBS",
    },
    amount: "29.70 EUR",
    payer: {
      country: "DE",
      name: "Jaber Moham",
    },
    logo: jcb,
    logoWidth: "32px",
    logoHeight: "25px"
  },
];

const columnWidths = {
    logo:"57px" ,
    id: "202px" ,
    terminal:"150px" ,
    amount:"60px" ,
    payer: "85px" ,
  };
  
  const TransactionTable = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          pb: 0,
          bgcolor: "lightPurple.400",
          borderRadius: "18px",
          width: "100%",
        }}
      >
        <TableContainer 
          component={Paper} 
          elevation={0} 
          sx={{ 
            bgcolor: "transparent",
            overflow: 'auto',
            '&::-webkit-scrollbar': {
              height: '8px',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: 'rgba(128, 119, 178, 0.5)',
              borderRadius: '4px',
            },
          }}
        >
          <Table sx={{ minWidth: isMobile ? 500 : 650 }}>
            <TableHead>
              <TableRow sx={{ borderBottom: 1, borderColor: "lightPurple.400" }}>
                <TableCell sx={{ border: "none", width: columnWidths.logo }} />
                <TableCell sx={{ border: "none", width: columnWidths.id }}>
                  <Typography variant="caption" sx={{ color: "lightPurple.500", fontWeight: 500 }}>
                    ID
                  </Typography>
                </TableCell>
                <TableCell sx={{ border: "none", width: columnWidths.terminal }}>
                  <Typography variant="caption" sx={{ color: "lightPurple.500", fontWeight: 500 }}>
                    TERMINAL
                  </Typography>
                </TableCell>
                <TableCell sx={{ border: "none", textAlign: "center", width: columnWidths.amount }}>
                  <Typography variant="caption" sx={{ color: "lightPurple.500", fontWeight: 500 }}>
                    AMOUNT
                  </Typography>
                </TableCell>
                <TableCell sx={{ border: "none", width: columnWidths.payer }}>
                  <Typography variant="caption" sx={{ color: "lightPurple.500", fontWeight: 500 }}>
                    PAYER
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {transactionData.map((transaction, index) => (
                <TableRow
                  key={index}
                  sx={{
                    borderBottom: index < transactionData.length - 1 ? 1 : 0,
                    borderColor: "lightPurple.400",
                    "&:hover": { bgcolor: "lightPurple.300" },
                    cursor: "pointer",
                  }}
                >
                  <TableCell sx={{ border: "none", py: { xs: 1.5, sm: 2.5 }, px: { xs: 1, sm: 2 } }}>
                    <Box
                      sx={{
                        width: "57px" ,
                        height: "35px" ,
                        bgcolor: "beige.100",
                        borderRadius: "5px",
                        mixBlendMode: "hard-light",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "6px 12.92px 5.06px 13px"
                      }}
                    >
                      <Box
                        component="img"
                        src={transaction.logo}
                        alt="Payment method logo"
                        sx={{
                          width: transaction.logoWidth,
                          height: transaction.logoHeight,
                          objectFit: "cover",
                            opacity: 0.7
                        }}
                      />
                    </Box>
                  </TableCell>
  
                  <TableCell sx={{ border: "none", py: { xs: 1.5, sm: 2.5 }, px: { xs: 1, sm: 2 } }}>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                      {[transaction.id.line1, transaction.id.line2, transaction.id.line3].map((line, i) => (
                        <Box key={i} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                          <Files sx={{ width: { xs: 18, sm: 24 }, height: { xs: 18, sm: 24 } }} />
                          <Typography 
                            variant="caption" 
                            sx={{ 
                              color: i === 1 ? "lightPurple.500" : "darkPurple.500", 
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {line}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  </TableCell>
  
                  <TableCell sx={{ border: "none", py: { xs: 1.5, sm: 2.5 }, px: { xs: 1, sm: 2 } }}>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                      <Typography 
                        variant="caption" 
                        sx={{ 
                          color: "lightPurple.500"
                        }}
                      >
                        {transaction.terminal.type}
                      </Typography>
                      <Typography 
                        variant="caption" 
                        sx={{ 
                          color: "darkPurple.500", 
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {transaction.terminal.code}
                      </Typography>
                    </Box>
                  </TableCell>
  
                  <TableCell sx={{ border: "none", py: { xs: 1.5, sm: 2.5 }, px: { xs: 1, sm: 2 }, textAlign: "center" }}>
                    <Typography 
                      variant="caption" 
                      sx={{ 
                        color: "lightPurple.500", 
                      }}
                    >
                      {transaction.amount}
                    </Typography>
                  </TableCell>
  
                  <TableCell sx={{ border: "none", py: { xs: 1.5, sm: 2.5 }, px: { xs: 1, sm: 2 } }}>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                      <Typography 
                        variant="caption" 
                        sx={{ 
                          color: "darkPurple.500", 
                        }}
                      >
                        {transaction.payer.country}
                      </Typography>
                      <Typography 
                        variant="caption" 
                        sx={{ 
                          color: "lightPurple.500", 
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {transaction.payer.name}
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  };
  
  export default TransactionTable;